import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../dynamic-form/field-interface';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProductService } from 'src/app/services/product.service';
import { downloads, downloadsNew } from '../../utils/calsoft-validators';

@Component({
  selector: 'calsoft-simple-pdf-download',
  templateUrl: './simple-pdf-download.component.html',
  styleUrls: ['./simple-pdf-download.component.scss']
})
export class SimplePdfDownloadComponent {

  @Output() valueChange = new EventEmitter<any>();
  field: FieldConfig;
  group: UntypedFormGroup;
  text: string;
  public serverPath = environment.commonImageApi + 'gallery/';

  public serverPath1 = environment.commonImageApi + 'gallery1/';

  value: any;
  reInit: boolean = false;
  imageList: any[];
  @Input() customField13: any = 0;
  imagename: string;

  constructor(
    private snackBar: MatSnackBar,
    private productService: ProductService,) {
  }


  finalValue: any;

  ngOnInit(): void {


  }

  downloadPdf(value) {
    let smallImage = "/formPdf/" + value;
    this.productService.downloadPdf(smallImage).subscribe(
      data => {
        downloadsNew(data, value);
      },
    )
  }

}


